import { WorkflowTypeCreatedByEnum } from '~/client/src/shared/enums/WorkflowTypeCreatedBy'

export enum FormTypeColumnId {
  Checkbox = 'checkbox',
  Icon = 'icon',
  Name = 'name',
  Category = 'category',
  ShowInApp = 'showInApp',
  AvailableTo = 'availableTo',
  CreatedBy = 'createdBy',
  LastUpdated = 'lastUpdated',
}

// Audience facet buckets for the AvailableTo column — stable keys the facet
// filters on; display labels come from the localized formatter.
export const AUDIENCE_ADMIN_ONLY = 'adminOnly'
export const AUDIENCE_EVERYONE = 'everyone'

// Facet key for the App (Show-in-App) drilldown filter. Distinct from the
// ShowInApp column id so the facet and the table column never collide.
export const APP_FACET_KEY = 'app'

// App grouping/facet bands. Show-in-App is a single boolean, so the only two
// states are shown / hidden — the legacy Home+Forms duality flipped the same
// flag and is intentionally dropped.
export const SHOWN_BAND_KEY = 'shown'
export const HIDDEN_BAND_KEY = 'hidden'

export interface IFormTypeRow {
  id: string
  // PermitType.type — onRemoveTypes deletes by stable `type`, not id.
  type: string
  name: string
  iconName?: string
  categoryId: string
  categoryName: string
  isEnabled: boolean
  isAdminOnly: boolean
  createdBy: WorkflowTypeCreatedByEnum
  createdByCaption: string
  lastUpdatedDisplay: string
  lastUpdatedSortValue: number
  isDeletable: boolean
}
